/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  clusterId: ZodTypes.Id,
});

export const DatasetImportGet = {
  id: 'dataset-import.get',
  tag: 'Inventory',
  summary: 'Get Imported Dataset',
  description: 'Imported dataset',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.clusterId}/dataset-import`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(
            z.strictObject({
              id: z.string(),
              database: z.string(),
              isReadonly: z.boolean(),
              isPresent: z.boolean(),
              isConflictingOid: z.boolean(),
              status: z.string(),
              operations: z
                .array(
                  z.strictObject({
                    id: ZodTypes.Id,
                    type: z.string(),
                    importStart: z.date().nullish(),
                    importFinish: z.date().nullish(),
                    result: z.string().nullish(),
                    creator: z
                      .strictObject({
                        id: ZodTypes.Id,
                        email: z.string().email(),
                        firstName: z.string(),
                        middleName: z.string().nullish(),
                        lastName: z.string(),
                      })
                      .nullish(),
                  }),
                )
                .optional(),
              dataset: z.strictObject({
                id: z.string(),
                name: z.string(),
                description: z.string().optional(),
                database: z.string(),
                schema: z.string(),
                extensions: z.array(z.string()).nullish(),
                finalSizeMb: z.string(),
                importSizeMb: z.string(),
                visible: z.boolean(),
                exists: z.boolean(),
                createdAt: z.date(),
                updatedAt: z.date(),
                category: z.strictObject({
                  id: z.string(),
                  i18n: z
                    .strictObject({
                      title: z.string(),
                    })
                    .optional(),
                }),
              }),
              allowReimport: z.boolean(),
            }),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
